import { InteractionLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import React, { useContext, useState, useEffect, useCallback } from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { useTrackingManager } from '../../../../../tracking/use-tracking-manager';
import { ClubSettingsLayer } from '../layer/club-settings-layer';
import { formatOwnership } from '../../../../../tracking/tracking-helper';
import { UpdatingProvider, useSetUpdating } from '../../../../../context/updating-context';

export const useClubSettingsLayer = () => {
	const portalContext = useContext(PortalContext);
	const setUpdating = useSetUpdating();
	const trackingManager = useTrackingManager();
	const userVehicles = portalContext.portalService.getPersonVehicles().getValue();

	const [isLayerOpen, setIsLayerOpen] = useState(false);

	const handleLayerOpen = () => {
		trackingManager.trackClubVWButtonClick(
			'Ajustes de mi membresía del Club Volkswagen',
			{
				contentId: 'Open Club Volkswagen settings Layer`',
			},
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		setIsLayerOpen(true);
	};

	useEffect(() => {
		if (isLayerOpen) {
			trackingManager.trackClubVWLayerLoad(
				{ contentId: 'Club Volkswagen settings Layer' },
				{ vehicle: formatOwnership(userVehicles?.vehicles) },
			);
		}
	}, [isLayerOpen, trackingManager, userVehicles]);

	const handleLayerClose = useCallback(() => {
		setIsLayerOpen(false);
		trackingManager.trackClubVWLayerCloseClick('Club Volkswagen settings Layer', {
			contentId: 'Club Volkswagen settings Layer',
		});
	}, [trackingManager]);

	useEffect(() => {
		if (!isLayerOpen) return;

		const layer = portalContext.layerManager.openInteractionLayer(
			() => (
				<UpdatingProvider setUpdating={setUpdating}>
					<ClubSettingsLayer portalContext={portalContext} onClose={handleLayerClose} />
				</UpdatingProvider>
			),
			{},
			{
				size: InteractionLayerSizeV2.B,
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
			},
		);

		return () => {
			layer.close();
		};
	}, [isLayerOpen, portalContext, handleLayerClose]);

	return {
		handleLayerOpen,
	};
};
